module.exports = __webpack_public_path__ + "static/media/forgotPassword.743d21b2.svg";